import classNames from 'clsx';
import format from 'date-fns/format';
import { ReactComponent as MailIcon } from 'img/icons/mailru.svg';
import React, { memo, ReactElement } from 'react';
import { IS_MY_TEAM } from 'reactApp/appHelpers/configHelpers';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { NameComponent } from 'reactApp/ui/Name/Name';
import { ProtectedHint } from 'reactApp/ui/ProtectedHint/ProtectedHint';

import styles from './AttachInfo.css';

interface Props {
    name: string;
    author: string;
    fileName: string;
    fileExt: string;
    size: string;
    timestamp: number;
    isTemporary: boolean;
    onClick();
}

export const AttachInfo = memo(({ name, author, timestamp, onClick, fileName, fileExt, size, isTemporary }: Props): ReactElement | null => {
    const fileTitle = `${fileName}.${fileExt}`;

    return (
        <div
            className={classNames(styles.root, { [styles.rootClickable]: !isTemporary && !IS_MY_TEAM })}
            onClick={IS_MY_TEAM ? undefined : onClick}
        >
            <div className={styles.iconWrapper}>
                <MailIcon />
            </div>
            <div className={styles.attachBlock}>
                <div className={styles.attachTopBlock}>
                    <div className={styles.author}>{Boolean(author) && author}</div>
                    <div className={styles.attachTime}>{Boolean(timestamp) && format(timestamp, 'dd.MM.yy, HH:mm')}</div>
                </div>
                <div className={styles.attachBottomBlock}>
                    {name && (
                        <Hint text={name} theme="dark" showDelay>
                            <div className={styles.attachName}>{name}</div>
                        </Hint>
                    )}
                    {fileTitle && (
                        <Hint text={fileTitle} theme="dark" showDelay>
                            <div className={classNames({ [styles.attachItemPrefix]: name })}>
                                <NameComponent name={fileName} extension={fileExt} />
                            </div>
                        </Hint>
                    )}
                    {size && <div className={classNames({ [styles.attachItemPrefix]: fileTitle })}>{size}</div>}
                    <ProtectedHint text="Файл проверен антивирусом Касперского" />
                </div>
            </div>
        </div>
    );
});

AttachInfo.displayName = 'AttachInfo';

AttachInfo.whyDidYouRender = true;
